import { gql } from '@apollo/client';
import { POLICY_FIELDS_FRAGMENT } from './fragments';

/**
 * Create new policy
 */
export const CREATE_POLICY = gql`
  ${POLICY_FIELDS_FRAGMENT}
  mutation CreatePolicy($tenantId: String!, $input: CreatePolicyInput!) {
    createPolicy(tenantId: $tenantId, input: $input) {
      ...PolicyFields
    }
  }
`;

/**
 * Update existing policy
 */
export const UPDATE_POLICY = gql`
  ${POLICY_FIELDS_FRAGMENT}
  mutation UpdatePolicy($tenantId: String!, $policyId: String!, $input: UpdatePolicyInput!) {
    updatePolicy(tenantId: $tenantId, policyId: $policyId, input: $input) {
      ...PolicyFields
    }
  }
`;

/**
 * Delete policy (soft delete)
 */
export const DELETE_POLICY = gql`
  mutation DeletePolicy($tenantId: String!, $policyId: String!) {
    deletePolicy(tenantId: $tenantId, policyId: $policyId)
  }
`;

/**
 * Enable policy for runtime evaluation
 */
export const ENABLE_POLICY = gql`
  ${POLICY_FIELDS_FRAGMENT}
  mutation EnablePolicy($tenantId: String!, $policyId: String!) {
    enablePolicy(tenantId: $tenantId, policyId: $policyId) {
      ...PolicyFields
    }
  }
`;

/**
 * Disable policy from runtime evaluation
 */
export const DISABLE_POLICY = gql`
  ${POLICY_FIELDS_FRAGMENT}
  mutation DisablePolicy($tenantId: String!, $policyId: String!) {
    disablePolicy(tenantId: $tenantId, policyId: $policyId) {
      ...PolicyFields
    }
  }
`;

/**
 * Add new rule to existing policy
 */
export const ADD_POLICY_RULE = gql`
  ${POLICY_FIELDS_FRAGMENT}
  mutation AddPolicyRule($tenantId: String!, $policyId: String!, $rule: PolicyRuleInput!) {
    addPolicyRule(tenantId: $tenantId, policyId: $policyId, rule: $rule) {
      ...PolicyFields
    }
  }
`;

/**
 * Remove rule from policy by name
 */
export const REMOVE_POLICY_RULE = gql`
  ${POLICY_FIELDS_FRAGMENT}
  mutation RemovePolicyRule($tenantId: String!, $policyId: String!, $ruleName: String!) {
    removePolicyRule(tenantId: $tenantId, policyId: $policyId, ruleName: $ruleName) {
      ...PolicyFields
    }
  }
`;
